import { render, staticRenderFns } from "./ObjectivesEditorLegacy.vue?vue&type=template&id=26af7d50&scoped=true&"
import script from "./ObjectivesEditorLegacy.vue?vue&type=script&lang=js&"
export * from "./ObjectivesEditorLegacy.vue?vue&type=script&lang=js&"
import style0 from "./ObjectivesEditorLegacy.vue?vue&type=style&index=0&id=26af7d50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26af7d50",
  null
  
)

export default component.exports